
































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import appModule from '@/model/store/modules/app-module';
import contentsModule from '@/model/store/modules/contents-module';
import detailModule from '@/model/store/modules/detail-module';
import headerModule from '@/model/store/modules/header-module';
import userModule from '@/model/store/modules/user-module';
import userService from '@/model/services/user-service';
import UsersForm from '@/components/molecules/UsersForm.vue';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
    'users-form': UsersForm
  }
})
export default class UserFormDialog extends Vue {
  /** Data **/
  private display: boolean = false;
  private data: any; // 確定ボタン押下時に親側のイベントで使いたいデータ
  private feedbacks: any; // 確定ボタン押下時に親側のイベントで使いたいデータ
  private time: number = 1000;
  private type: string = '';

  /** Props **/
  @Prop({default: ''}) public title!: string;
  @Prop({default: ''}) public message!: string;

  get upsertStatus() {
    return userModule.upsertStatus;
  }

  get text() {
    return {
      confirmation: GlobalConstants.TEXT.SAVECONFIRMATION,
      confirm: GlobalConstants.TEXT.CONFIRM,
      cancel: GlobalConstants.TEXT.CANCEL
    };
  }

  /** Methods **/
  public open(param?: any): void {
    this.display = true;
    // this.data = param.data; // 確定ボタンを押下した際に用いる情報
    this.type = param.type;
  }

  public close(): void {
    this.display = false;
  }

  private onPushCancelBtn(): void {
    this.close();
  }

  @Watch('upsertStatus')
  private async doUpsertStatus() {
    await headerModule.requestHeaderInfo(1);
    this.close();
  }

  @Emit('onPushEnterBtn')
  private async onPushEnterBtn(): Promise<void> {
    appModule.startLoading();
    this.close();
    const func = _.debounce( async () => {
      userService.requestUserInfo();
      appModule.stopLoading();
    }, this.time);
    func();
  }
}
